import { render, staticRenderFns } from "./FnsExistingCertList.vue?vue&type=template&id=064e9d66&"
import script from "./FnsExistingCertList.vue?vue&type=script&lang=ts&"
export * from "./FnsExistingCertList.vue?vue&type=script&lang=ts&"
import style0 from "./FnsExistingCertList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports